module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-arrange-82f4e26276ba15d5e7334fd28b6ff05e.svg";